import FragmentShader from "./fragment.glsl"
import VertexShader from "./vertex.glsl"
import GridFragmentShader from "./grid.fragment.glsl"
import GridVertexShader from "./grid.vertex.glsl"

import * as THREE from "three";

export default class {
    constructor({
        scene
    }) {
        this.makeGrid({
            scene
        })
        var geometry = new THREE.SphereGeometry(5, 32, 32);
        var material = new THREE.RawShaderMaterial({
            depthWrite: false,
            vertexShader: VertexShader,
            fragmentShader: FragmentShader,
            side: THREE.BackSide,
            uniforms: {
                offset: new THREE.Uniform(0),
                gamma: {
                    value: 1.125
                }
            }
        });
        this.mesh = new THREE.Mesh(geometry, material);
        scene.add(this.mesh);
    }
    makeGrid({
        scene
    }) {
        const geometry = new THREE.PlaneGeometry(1, 1)
        var material = new THREE.RawShaderMaterial({
            depthWrite: false,
            transparent: true,
            vertexShader: GridVertexShader,
            fragmentShader: GridFragmentShader,
            extensions: {
                derivatives: true,
                fragDepth: false,
                drawBuffers: false,
                shaderTextureLOD: false
            },
            uniforms: {
                resolution: new THREE.Uniform(new THREE.Vector2(window.innerWidth, window.innerHeight)),
                offset: new THREE.Uniform(new THREE.Vector2())
            }
        });
        this.plane = new THREE.Mesh(geometry, material)
        this.plane.position.z = 0
        // plane.frustumCulled = false
        // scene.add(this.plane)
    }
    dispose() {
        this.mesh.geometry.dispose();
        this.mesh.material.dispose();
    }
}